var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconQuotes = function SvgIconQuotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.125 6.75A1.75 1.75 0 0 0 9.375 5H3.75A1.75 1.75 0 0 0 2 6.75v6a1.75 1.75 0 0 0 1.75 1.75h5.375v.5a2.75 2.75 0 0 1-2.75 2.75 1 1 0 1 0 0 2 4.75 4.75 0 0 0 4.75-4.75zM4 7v5.5h5.125V7zM22 6.75A1.75 1.75 0 0 0 20.25 5h-5.625a1.75 1.75 0 0 0-1.75 1.75v6a1.75 1.75 0 0 0 1.75 1.75H20v.5a2.75 2.75 0 0 1-2.75 2.75 1 1 0 1 0 0 2A4.75 4.75 0 0 0 22 15zM14.875 7v5.5H20V7z"
  }))));
};
export default SvgIconQuotes;